import { FC } from 'react'

import { Button, ButtonSizes, ButtonVariants } from '@inno-ui/button'
import { AnimatePresence, motion } from 'motion/react'

import styles from './InputActionButton.module.scss'
import { InputActionButtonProps } from './InputActionButton.types'

export const InputActionButton: FC<InputActionButtonProps> = ({
  show,
  size = ButtonSizes.L,
  variant = ButtonVariants.Ghost,
  ...buttonProps
}) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className={styles.actionButtonWrapper}
          initial={{ opacity: 0, width: 0 }}
          animate={{ opacity: 1, width: 'auto' }}
          exit={{ opacity: 0, width: 0 }}
          transition={{ duration: 0.2 }}
        >
          <Button size={size} variant={variant} {...buttonProps} />
        </motion.div>
      )}
    </AnimatePresence>
  )
}
